import { useState } from 'react';
import { CustomRolePermissionDto } from '../../../api-client';

type UseDeletePermissionFromCustomRoleModalFacade = () => {
  isCustomRolePermissionDeleteModalOpen: boolean;
  permissionToDelete: CustomRolePermissionDto | null;
  openCustomRolePermissionDeleteModal: (permission: CustomRolePermissionDto) => void;
  closeCustomRolePermissionDeleteModal: () => void;
};

export const useDeletePermissionFromCustomRoleModalFacade: UseDeletePermissionFromCustomRoleModalFacade =
  () => {
    const [isCustomRolePermissionDeleteModalOpen, setIsCustomRolePermissionDeleteModalOpen] =
      useState(false);
    const [permissionToDelete, setPermissionToDelete] = useState<null | CustomRolePermissionDto>(
      null,
    );

    const toggleCustomRolePermissionDeleteModal = () => {
      setIsCustomRolePermissionDeleteModalOpen((p) => !p);
    };

    const openCustomRolePermissionDeleteModal = (permission: CustomRolePermissionDto) => {
      setPermissionToDelete(permission);
      toggleCustomRolePermissionDeleteModal();
    };

    const closeCustomRolePermissionDeleteModal = () => {
      setPermissionToDelete(null);
      toggleCustomRolePermissionDeleteModal();
    };

    return {
      isCustomRolePermissionDeleteModalOpen,
      permissionToDelete,
      openCustomRolePermissionDeleteModal,
      closeCustomRolePermissionDeleteModal,
    };
  };
